import { useCallback, useState } from "react";
import { api, extractErrorMessage } from "../../../../util/api";
import { LoadingButton } from "../../../../components/LoadingButton";

export const RerunMedsenderAutoStatus = ({ onRun, ...rest }) => {
  const [_error, setError] = useState(null);
  const [running, setRunning] = useState(false);

  const handleRerun = useCallback(async () => {
    setRunning(true);

    try {
      const res = await api.get("/admin/auto_status_parsing_settings/rerun_medsender_auto_status");

      if (onRun) {
        onRun(res.data?.meta?.message, res.data?.meta?.error_details);
      }
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setRunning(false);
    }
  }, [onRun]);

  return (
    <>
      <LoadingButton
        title="Reruns Medsender Inbound Logic for the FaxQueue account cases last inbound fax."
        loading={running}
        onClick={handleRerun}
        {...rest}
      >
        Rerun Medsender Parser
      </LoadingButton>
    </>
  );
};
